import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import Home from "./components/pages/Home";

// Fundacao
import QuemSomos from "./components/pages/Fundacao/QuemSomos";
import DeficienciaVisual from "./components/pages/Fundacao/DeficienciaVisual";
import ComoConviverDeficienteVisual from "./components/pages/Fundacao/DeficienciaVisual/ComoConviverDeficienteVisual";
import Transparencia from "./components/pages/Fundacao/Transparencia";

// Nossa Atuação
import Noticias from "./components/pages/NossaAtuacao/Noticias";
import NewById from "./components/pages/NossaAtuacao/Noticias/NewById";

import Pesquisas from "./components/pages/NossaAtuacao/Pesquisas";
import PesquisaById from "./components/pages/NossaAtuacao/Pesquisas/PesquisaById";

import Eventos from "./components/pages/NossaAtuacao/Eventos";
import EventoById from "./components/pages/NossaAtuacao/Eventos/EventoById";

import Acoes from "./components/pages/NossaAtuacao/Acoes";
import AcoesById from "./components/pages/NossaAtuacao/Acoes/AcoesById";

// Impacto
import HistoriasDeVida from "./components/pages/Impacto/HistoriasDeVida";
import HistoriasDeVidaById from "./components/pages/Impacto/HistoriasDeVida/HistoriasDeVidaById";

import Depoimentos from "./components/pages/Impacto/Depoimentos";
import DepoimentosById from "./components/pages/Impacto/Depoimentos/DepoimentosById";

// Como Ajudar
import Doacao from "./components/pages/ComoAjudar/Doacao";
import ServicosVoluntarios from "./components/pages/ComoAjudar/ServicosVoluntarios";

import FaleConosco from "./components/pages/FaleConosco";

export default () => {
  return (
    <Switch>
      <Route exact path="/" component={Home} />

      <Route path="/fundacao/sobre" component={QuemSomos} />

      <Route
        path="/fundacao/deficiencia-visual/dicas-de-como-conviver-com-o-deficiente-visual"
        component={ComoConviverDeficienteVisual}
      />
      <Route
        path="/fundacao/deficiencia-visual"
        component={DeficienciaVisual}
      />
      <Route path="/fundacao/transparencia" exact component={Transparencia} />

      <Route path="/nossa-atuacao/noticias" exact component={Noticias} />
      <Route path="/nossa-atuacao/noticias/:slug" exact component={NewById} />

      <Route path="/nossa-atuacao/pesquisas" exact component={Pesquisas} />
      <Route
        path="/nossa-atuacao/pesquisas/:slug"
        exact
        component={PesquisaById}
      />

      <Route path="/nossa-atuacao/eventos" exact component={Eventos} />
      <Route path="/nossa-atuacao/eventos/:slug" exact component={EventoById} />

      <Route path="/nossa-atuacao/acoes" exact component={Acoes} />
      <Route path="/nossa-atuacao/acoes/:slug" exact component={AcoesById} />

      <Route
        path="/impacto/historias-de-vida"
        exact
        component={HistoriasDeVida}
      />
      <Route
        path="/impacto/historias-de-vida/:slug"
        exact
        component={HistoriasDeVidaById}
      />

      <Route path="/impacto/depoimentos" exact component={Depoimentos} />
      <Route
        path="/impacto/depoimentos/:slug"
        exact
        component={DepoimentosById}
      />

      <Route path="/como-ajudar/doacao" exact component={Doacao} />
      <Route
        path="/como-ajudar/servicos-voluntarios"
        exact
        component={ServicosVoluntarios}
      />

      <Route path="/contato" component={FaleConosco} />

      <Redirect from="*" to="/" />
    </Switch>
  );
};
